import { cn } from '../../utils/cn'

function Column({ title, subtitle, items, markClass, mark }) {
  return (
    <div className="flex flex-1 flex-col">
      <h2 className="font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
        {title}
      </h2>
      {subtitle && (
        <p className="pt-2 font-inter-regular text-base leading-[1.08] text-[#707070]">
          {subtitle}
        </p>
      )}
      <ul className="flex flex-col pt-6">
        {items.map((item, index) => (
          <li
            key={index}
            className={cn('flex items-start gap-3', index > 0 && 'pt-5')}
          >
            <span
              className={cn(
                'shrink-0 font-inter-bold text-base leading-[1.08]',
                markClass,
              )}
            >
              {mark}
            </span>
            <span className="font-inter-regular text-base leading-[1.08] text-[#454545]">
              {item}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

// Bloco "O QUE PROMETEMOS" (✓) × "O QUE NUNCA PROMETEMOS" (✕) com divisor
// vertical (frame 585:8619).
// promises/never: { title, subtitle, items[] }
export default function PromiseColumns({
  promises = { title: 'O QUE PROMETEMOS', subtitle: '', items: [] },
  never = { title: 'O QUE NUNCA PROMETEMOS', subtitle: '', items: [] },
  checkClass = 'text-[#264F8D]',
  crossClass = 'text-[#FB2C36]',
}) {
  return (
    <div className="flex w-full flex-col gap-10 px-20 py-10 md:flex-row md:justify-between md:gap-20">
      <Column
        title={promises.title}
        subtitle={promises.subtitle}
        items={promises.items}
        markClass={checkClass}
        mark="✓"
      />
      <div className="hidden w-px self-stretch bg-[#D9D9D9] md:block" />
      <Column
        title={never.title}
        subtitle={never.subtitle}
        items={never.items}
        markClass={crossClass}
        mark="✕"
      />
    </div>
  )
}
